import { ProductsList } from "../products-list";
import type { ProductsListProps } from "../products-list/products-list";
import { ProductsSummaryPrice } from "../products-summary-price";

type ProductsCardProps = ProductsListProps & {
  totalPrice: string | number;
  headerText?: string;
};

export const ProductsCard = ({ products, totalPrice, headerText, onRemoveProduct }: ProductsCardProps) => {
  if (products.length === 0) return null;

  return (
    <div className="rounded-lg border border-grey-200 border-solid bg-white p-6">
      {headerText && <h3 className="font-bold text-md">{headerText}</h3>}
      <ProductsList products={products} onRemoveProduct={onRemoveProduct} />
      <ProductsSummaryPrice price={totalPrice} className="mt-4 border-grey-200 border-t pt-4" />
    </div>
  );
};
